import { ApolloClient } from '@apollo/client'
import {
  GetUserCollectiblesCountQuery,
  GetUserCollectiblesCountQueryVariables,
  GetUserCollectibleOrdersCountQuery,
  GetUserCollectibleOrdersCountQueryVariables,
} from '@/types/codegen-federation'
import { logger } from '@/utils/logging'
import { GET_USER_COLLECTIBLES_COUNT, GET_USER_COLLECTIBLE_ORDERS_COUNT } from './querys'

/**
 * Get the count of user's collectibles on the server side
 * @param client Apollo federation client from getServerSidePropsErrorHandler
 * @returns Promise<number> - The count of user collectibles, or 0 if error/no collectibles
 */
export async function getUserCollectiblesCount(client: ApolloClient): Promise<number> {
  try {
    const { data } = await client.query<GetUserCollectiblesCountQuery, GetUserCollectiblesCountQueryVariables>({
      query: GET_USER_COLLECTIBLES_COUNT,
      errorPolicy: 'all',
    })

    return data?.user?.wallet?.niftyList?.count ?? 0
  } catch (error) {
    logger().warn('Error fetching user collectibles count', { error })
    return 0
  }
}

/**
 * Get the count of user's collectible orders on the server side
 * @param client Apollo federation client from getServerSidePropsErrorHandler
 * @returns Promise<number> - The count of user collectible orders, or 0 if error/no orders
 */
export async function getUserCollectibleOrdersCount(client: ApolloClient): Promise<number> {
  try {
    const { data } = await client.query<
      GetUserCollectibleOrdersCountQuery,
      GetUserCollectibleOrdersCountQueryVariables
    >({
      query: GET_USER_COLLECTIBLE_ORDERS_COUNT,
      errorPolicy: 'all',
    })

    return data?.getAllCollectibleOrdersForUser?.length ?? 0
  } catch (error) {
    logger().warn('Error fetching user collectible orders count', { error })
    return 0
  }
}
